export default "__VITE_ASSET__DDN_X0Y3__"